import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";
import { TFormSchema, TGridSchema, useTheme } from "@/comn/hooks";
import { lpcoEnvs, lpcoUtils } from "@/tz/go/egaz/osci/lpco/comn"; // 시스템 공통 유틸
import { useLocation } from "react-router-dom";
import { MASK } from "../../comn/LpcoConstants";

/*
 *  Access Statistics Services
 * !== 접속 통계 서비스 ==!
 */
export const BASE = {
    path: `${lpcoEnvs.base}/lpco/prcss`,
    api: `${process.env.REACT_APP_API_OSCI}/api/v1/osci/lpco/prcss/stts`,
};

export const URLS = {
    osci0501001q: `${BASE.path}/osci0206001q`,
};

export const APIS = {
    // Get a list of Access Statistics !== 접속 통계 목록 조회==!
    getLpcoPrcssStssList: (data: any) => {
        return api.get(`${BASE.api}`, { params: comnUtils.toGetParams(data) });
    },
};

export const SF_LPCO_PRCSS_STTS: TFormSchema = {
    id: "form_lpcoPrcssSts",
    schema: {
        srchAppNo: { type: "text", label: "L_APP_NO", edit: true } /* Application No !== 신청번호 ==!*/,
        srchUcrNo: {
            type: "text",
            label: "L_UCR_NO",
            edit: true,
            required: true,
            mask: MASK.UCR_NO,
        } /* UCR No !== UCR번호 ==!*/,
        orgCd: { type: "text", label: "L_OGA", edit: false },
    },
};

export const SG_LPCO_PRCSS_STTS_LIST: TGridSchema = {
    id: "grid_lpcoPrcssSttsList",
    options: { pagination: false, edit: false, index: true, height: 220 },
    head: [
        /* TANSAD 행이 "[TIN] 업체명" 이라 기관 약어보다 길다 (긴 업체명은 줄바꿈) */
        { cells: [{ header: "L_OGA", binding: "orgCd", width: "1.5*", minWidth: 140 }] },
        { cells: [{ header: "L_APP_NO", binding: "appNo", width: "1.8*", minWidth: 220 }] } /* Application No !== 신청번호 ==!*/,
        { cells: [{ header: "L_APP", binding: "appNm", width: "2.5*", minWidth: 230 }] } /* Application !== 신청서명(화면표시용) ==!*/,
        { cells: [{ header: "L_BLL_SET", binding: "bllSetNm", width: "*", minWidth: 105 }] } /* Bill Setting !== 고지 설정 ==!*/,
        { cells: [{ header: "L_BLL_ISSU", binding: "bllIssuNm", width: "*", minWidth: 105 }] } /* Bill Issuance !== 고지 발행 ==!*/,
        // {
        // cells: [{ header: "L_AMD_CNCL_YN", binding: "amdYn", width: 130 }],
        // } /* Amendment/Cancellation !== 정정·취소 여부 ==!*/,
        { cells: [{ header: "L_SBMT_DT", binding: "sbmtDtm", width: "1.3*", minWidth: 135 }] },
        { cells: [{ header: "L_APP_STTS", binding: "appStatCd", width: "1.3*", minWidth: 135 }] },
        { cells: [{ header: "L_FEE_CHRG", binding: "feeStatNm", width: "*", minWidth: 110 }] } /* Fee Charged !== 수수료 부과 여부 ==!*/,
        { cells: [{ header: "L_APRV_DT", binding: "aprvDtm", width: "1.3*", minWidth: 135 }] } /* Approval Date !== 승인일자 ==!*/,
    ],
    body: [
        // Rendered as plain text, not a code cell: TANSAD rows carry a "[TIN] Company" string
        // instead of an OGA code, which a code cell cannot resolve and would leave blank.
        { cells: [{ binding: "orgCd", align: "left" }] },
        { cells: [{ binding: "appNo", align: "center" }] },
        { cells: [{ binding: "appNm", align: "left" }] },
        // Both columns arrive as "Combined" / "Normal" text from the server (same wording as Bill Type: Combined Bill / Normal Bill).
        // Bill Setting is "N/A" when the LPCO has no fee setting; Bill Issuance is "N/A" when no bill will be issued (rejected, non-regulated, zero fee), and blank when not decided yet.
        // !== 두 컬럼 모두 서버가 "Combined" / "Normal" 문자로 보낸다(Bill Type 의 Combined Bill / Normal Bill 과 같은 표기).
        //     Bill Setting 은 수수료 설정이 없으면 "N/A", Bill Issuance 는 고지서가 나가지 않으면(거절, 비규제, 0원) "N/A", 아직 정할 수 없으면 빈칸. ==!
        { cells: [{ binding: "bllSetNm", align: "center" }] },
        { cells: [{ binding: "bllIssuNm", align: "center" }] },
        // {
        //     cells: [
        //         {
        //             binding: "amdYn",
        //             align: "center",
        //             area: "comnCd",
        //             comnCd: "OSC0063",
        //             type: "code",
        //             viewType: "label",
        //         },
        //     ],
        // },
        { cells: [{ binding: "sbmtDtm", type: "datetime", align: "center" }] },
        {
            cells: [
                {
                    binding: "appStatCd",
                    align: "left",
                    area: "comnCd",
                    comnCd: "OSC0121",
                    type: "select",
                },
            ],
        },
        // "Yes" / "No" / "Not Required" text from the server (same wording as the "Fee Charged" processing history); blank when there is no fee yet.
        // !== 서버가 "Yes" / "No" / "Not Required" 문자로 보낸다(처리 이력 "Fee Charged" 와 같은 용어). 수수료가 없으면 빈칸. ==!
        { cells: [{ binding: "feeStatNm", align: "center" }] },
        { cells: [{ binding: "aprvDtm", type: "datetime", align: "center" }] },
    ],
};

export const SG_BLL_PRCSS_STTS_LIST: TGridSchema = {
    id: "grid_bllPrcssSttsList",
    options: { pagination: false, edit: false, index: true, height: 220 },
    head: [
        // Main bill and linked bill-detail rows are returned together by the processing-status API.
        // { cells: [{ header: "Bill Level", binding: "bllRowTpNm", width: 100 }] },
        { cells: [{ header: "L_BLL_TP", binding: "bllTpCd", width: 150, rowspan: 2 }] },
        { cells: [{ header: "L_OGA", binding: "orgCd", width: "*", rowspan: 2 }] },
        {
            cells: [
                { header: "L_APP_NO", binding: "appNo", width: "*" } /* Application No !== 신청번호 ==!*/,
                { header: "L_APP", binding: "appNm" } /* Application !== 신청서명(화면표시용) ==!*/,
            ],
        },
        { cells: [{ header: "L_BLL_GNRT_DT", binding: "bllGnrtDt", width: 120, rowspan: 2 }] },
        {
            // BLL_NO is 15 chars and CTRL_NO up to 16 chars in the DB, so 150 fits both stacked rows.
            cells: [
                { header: "L_BLL_NO", binding: "bllNo", width: 180 },
                { header: "L_CTRL_NO", binding: "ctrlNo" },
            ],
        },
        { cells: [{ header: "L_PAY_DT", binding: "payDtm", width: 120, rowspan: 2 }] },
        { cells: [{ header: "L_BLL_STAT", binding: "bllStatCd", width: 200, rowspan: 2 }] },
    ],
    body: [
        // { cells: [{ binding: "bllRowTpNm", align: "center" }] },
        {
            cells: [
                { binding: "bllTpCd", area: "comnCd", comnCd: "OSC0166", type: "code", viewType: "label", rowspan: 2 },
            ],
        },
        { cells: [{ binding: "orgCd", align: "left", rowspan: 2 }] },
        {
            cells: [
                { binding: "appNo", align: "center" },
                { binding: "appNm", align: "left" },
            ],
        },
        { cells: [{ binding: "bllGnrtDt", type: "date", rowspan: 2 }] },
        {
            cells: [
                { binding: "bllNo", align: "center" },
                { binding: "ctrlNo", align: "center" },
            ],
        },
        { cells: [{ binding: "payDtm", type: "date", rowspan: 2 }] },
        {
            cells: [
                {
                    binding: "bllStatCd",
                    type: "code",
                    area: "comnCd",
                    comnCd: "OSC0056",
                    viewType: "label",
                    rowspan: 2,
                },
            ],
        },
    ],
};

export const SG_LPCO_HIST_LIST: TGridSchema = {
    id: "grid_lpcoHistList",
    // 처리 이력은 최신 건이 맨 위에 오도록 조회되므로 순번도 역순으로 매긴다
    options: { pagination: false, edit: false, index: "DESC", height: "auto" },
    head: [
        { cells: [{ header: "L_APP", binding: "lpcoNm", width: "*", rowspan: 2 }] },
        {
            cells: [
                { header: "Processing Type", binding: "prcssStatNm", width: 180 },
                { header: "Processing Date", binding: "prcssDtm" },
            ],
        },
        { cells: [{ header: "L_OGA", binding: "orgCd", width: "*", rowspan: 2 }] },
        { cells: [{ header: "L_APP_NO", binding: "lpcoNo", width: 200, rowspan: 2 }] },
        {
            cells: [
                { header: "L_BLL_NO", binding: "bllNo", width: 180 },
                { header: "L_CTRL_NO", binding: "ctrlNo" },
            ],
        },
        { cells: [{ header: "L_RMRK", binding: "rmrk", width: "0.8*", rowspan: 2 }] },
    ],
    body: [
        { cells: [{ binding: "lpcoNm", align: "left", rowspan: 2 }] },
        {
            cells: [
                { binding: "prcssStatNm", align: "center" },
                { binding: "prcssDtm", type: "datetime", align: "center" },
            ],
        },
        { cells: [{ binding: "orgCd", align: "left", rowspan: 2 }] },
        { cells: [{ binding: "lpcoNo", align: "center", rowspan: 2 }] },
        {
            cells: [
                { binding: "bllNo", align: "center" },
                { binding: "ctrlNo", align: "center" },
            ],
        },
        { cells: [{ binding: "rmrk", align: "left", rowspan: 2 }] },
    ],
};
